import { createSelector } from 'reselect';
import { RootPatronState } from '../../common/use-patron-selector';

const session = (state: RootPatronState) => state.session || null;

const getSession = createSelector([session], (session) => session);

const getSessionIsSSO = createSelector(
  [session],
  (session) => session?.service === 'sso'
);

export default {
  getSession,
  getSessionIsSSO,
};
